module.exports = __webpack_public_path__ + "static/triangle_background4-744abffa261f26c4e7710dd0938d0206.jpg";